var _path, _circle, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3650({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9814 16.2083C13.4602 15.6046 13.4933 14.701 14.0573 14.1371C14.6244 13.57 15.5342 13.5401 16.1373 14.0689L22.1927 19.3783C23.0976 20.1718 23.1433 21.565 22.2923 22.416C21.4368 23.2715 20.0348 23.2201 19.2441 22.3043L13.9814 16.2083Z",
    fill: "#2DAACD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9322,
    cy: 11.9332,
    r: 7.41655,
    fill: "#467487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0171 11.9333C21.0171 10.1003 20.4625 8.31006 19.4263 6.79795C18.3901 5.28584 16.9207 4.12257 15.2112 3.46097C13.5017 2.79937 11.632 2.67041 9.84784 3.09102C8.06366 3.51163 6.44846 4.46214 5.21446 5.81765C3.98046 7.17317 3.18538 8.87028 2.93369 10.686C2.68201 12.5017 2.98549 14.3511 3.80427 15.9912C4.62304 17.6312 5.91881 18.9852 7.52131 19.8753C9.1238 20.7653 10.9581 21.1498 12.7831 20.9781",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "40 40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8664 11.9332C22.8664 9.72715 22.1991 7.57268 20.952 5.7529C19.705 3.93311 17.9366 2.53314 15.8792 1.73693C13.8219 0.940719 11.5717 0.785513 9.42453 1.29171C7.27733 1.7979 5.33348 2.94181 3.84838 4.57314C2.36329 6.20447 1.40644 8.2469 1.10354 10.4321C0.800649 12.6172 1.16588 14.8429 2.15126 16.8167C3.13663 18.7905 4.69605 20.42 6.62461 21.4911C8.55318 22.5623 10.7607 23.025 12.957 22.8184",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "40 40"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.955,
    cy: 11.9558,
    r: 6.44721,
    fill: "#D1DEE0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.955,
    cy: 11.9558,
    r: 6.44721,
    fill: "#D1DEE0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9321,
    cy: 11.9331,
    r: 5.25245,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9321,
    cy: 11.9331,
    r: 5.25245,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.75586,
    y: 10.9187,
    width: 1.12714,
    height: 3.56175,
    fill: "#908EC3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4668,
    y: 9.38574,
    width: 1.12714,
    height: 5.09465,
    fill: "#FBCF4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1348,
    y: 11.5049,
    width: 1.12714,
    height: 2.97564,
    fill: "#3BB3C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8047,
    y: 10.5581,
    width: 1.12714,
    height: 3.92243,
    fill: "#F475B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3650);
export default __webpack_public_path__ + "static/media/Group 3650.6fb45a9ba2341070d2657112bce97dae.svg";
export { ForwardRef as ReactComponent };